/*
  GBAC 2026-10-04: "Notify Me" -> Klaviyo Back in Stock (account W46WFL).

  Broadcast's notification form posts to Shopify's contact endpoint, which only
  lands as a general inquiry with no restock email behind it. This listens in the
  CAPTURE phase for CLICKS on the form's submit button (Enter in the email field
  synthesizes the same click). It cannot use the submit event: Shopify's hCaptcha
  protection on contact forms takes the submit event first and never re-dispatches
  it (verified 2026-10-04, headless test on the live PDP). It subscribes the email to the selected variant through Klaviyo's
  client API. Klaviyo's Back in Stock flow then emails the subscriber when the
  variant's inventory comes back.

  Fallback: on any failure (no email, no variant id, network or non-2xx), the
  marker attribute is removed and the form is re-submitted, so Broadcast's
  original contact-form behaviour runs exactly as before and no sign-up is lost.
*/
(function () {
  'use strict';

  var COMPANY_ID = 'W46WFL';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID;
  var MARKER = 'data-klaviyo-bis';

  function selectedVariantId(form) {
    var scope = form.closest('.shopify-section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return (input && input.value) || form.getAttribute('data-fallback-variant-id') || '';
  }

  function fallback(form) {
    form.removeAttribute(MARKER);
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function showSuccess(form) {
    var popup = form.closest('popup-component');
    var heading = form.closest('product-notification');
    heading = heading && heading.querySelector('[data-product-notification-heading]');
    if (heading) heading.classList.add('hidden');
    if (popup) popup.classList.add('has-success');

    var message = document.createElement('div');
    message.className = 'product__notification__message';
    var p = document.createElement('p');
    p.textContent = form.getAttribute('data-success-text') || '';
    message.appendChild(p);

    var fields = form.querySelector('.product__notification__form');
    if (fields) fields.hidden = true;
    form.insertBefore(message, form.firstChild);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('button[type="submit"]');
    var form = trigger && trigger.form;
    if (!form || !form.hasAttribute(MARKER)) return;
    if (!form.checkValidity()) return; // let the browser show its own "enter an email" message

    event.preventDefault();
    event.stopImmediatePropagation();

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = selectedVariantId(form);
    if (!email || !variantId) {
      fallback(form);
      return;
    }

    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    };

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo BIS ' + response.status);
        showSuccess(form);
      })
      .catch(function () {
        if (button) button.disabled = false;
        fallback(form);
      });
  }, true);
})();
